export enum ExpenseStatus {
  Bill = "Bill",
  Gift = "Gift",
}
